import { Card,Image, Button } from "react-bootstrap";
import styles from "@/styles/Questions.module.scss"; // Adjust the import to your actual stylesheet path
import { decodeHtml } from "@/utils/helpers";
import { useRouter } from "next/router";

const BlogCard = ({ blog,classNameMargin }: any) => {
  const router =useRouter()
  return (
    <div className={styles.res}>
    
      {/* <Row className="no-gutters "> */}
      <Card className={` card-blog pointer ${classNameMargin} ${styles.buttonAnimate}`} onClick={(e) => {
                  e.preventDefault()
                  if (e?.ctrlKey)
                    window.open(`/resources/blog/${blog?.attributes?.Slug}`, '_blank')
                  else
                  router.push(`/resources/blog/${blog?.attributes?.Slug}`)
                // .then(() => {
                //     window.scrollTo(0, 0); // Scrolls to the top of the page after navigation
                //   });
                }
                }>
          <div className="blog-img-fluid">
            <Image fluid
              src={
                blog?.attributes?.BannerThumb?.data?.attributes?.url
                
              }
              alt={blog?.attributes?.alternativeText || "technologies"}
             
              className="img-fluid blog-card-img"
              height={blog?.attributes?.Banner?.data?.attributes?.height}
              width={blog?.attributes?.Banner?.data?.attributes?.width}
            />
          </div>
          <Card.Body className="text-blog">
            <Card.Title className="m-0 he">{decodeHtml(blog?.attributes?.Title)}</Card.Title>
            <Card.Text className="">
              {decodeHtml(blog?.attributes?.Content)
                ?.replace(/<\/?[^>]+(>|$)/g, "")
                ?.substring(0,  100)}
              ...
            </Card.Text>
            <Button className="animated-button res-read">Read More</Button>
          </Card.Body>
        </Card>
      {/* </Row> */}
    
    </div>
  );
};

export default BlogCard;
